import { render } from "./v-task-details.vue?vue&type=template&id=230088a3"
import script from "./v-task-details.vue?vue&type=script&lang=js"
export * from "./v-task-details.vue?vue&type=script&lang=js"

import "./v-task-details.vue?vue&type=style&index=0&id=230088a3&lang=css"

import exportComponent from "/builds/simplecrm/simplecrmfront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__